"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Encroachment = function Encroachment(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    (0, _extends3.default)({ viewBox: "0 0 64 64", className: "custom-icon" }, props),
    _react2.default.createElement("path", { d: "m59 7v-3c0-1.654-1.346-3-3-3h-26c-1.654 0-3 1.346-3 3v3h-4v16.811l-2-1.344v-.247c0-1.775-1.444-3.22-3.22-3.22-1.52 0-2.812 1.037-3.144 2.521l-3.439 15.479h-1.932l-5 16h-.265c-1.654 0-3 1.346-3 3v7h28 2 32v-56zm-30-3c0-.551.448-1 1-1h26c.552 0 1 .449 1 1v3h-28zm32 5v2h-36v-2zm-38 17.22v11.627l-.265-.847h-1.735v-12.124zm-15.041 21.664 5.309 2.171-6.884 2.868zm1.99-1.347 6.051-3.698 5.914 3.614-6.029 2.512zm5.942 4.592 4.576 1.871h-9.067zm2.618-1.091 5.49-2.288 1.624 5.197zm4.491-5.266-5.082-3.105 3.51-2.145 1.572 5.031zm-7-4.278-2.445-1.494h4.891zm.589-18.538c.126-.563.616-.956 1.191-.956.673 0 1.22.547 1.22 1.22v14.78h-5.753zm-6.017 17.566 3.51 2.145-5.167 3.157zm-7.572 21.478v-5c0-.551.448-1 1-1h24c.552 0 1 .449 1 1v5zm28 0v-5c0-1.654-1.346-3-3-3h-.265l-2.735-8.752v-16.685l9.971 6.698c-.43 2-1.647 3.778-3.486 4.881l-1.428.858 1.429.857c2.684 1.61 4.084 4.644 3.569 7.731l-.27 1.628 1.627-.272c3.084-.509 6.12.886 7.73 3.57l.858 1.429.857-1.429c1.609-2.683 4.641-4.085 7.729-3.57l1.628.272-.27-1.63c-.515-3.085.886-6.12 3.569-7.729l1.43-.857-1.429-.857c-2.684-1.61-4.084-4.644-3.569-7.731l.27-1.628-1.627.272c-3.08.512-6.12-.886-7.73-3.57l-.858-1.429-.857 1.429c-1.609 2.683-4.643 4.084-7.729 3.57l-1.628-.272.27 1.63c.029.177.031.351.048.527l-10.104-6.787v-12.154h36v48zm14-27c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6zm0 14c4.411 0 8-3.589 8-8s-3.589-8-8-8c-2.34 0-4.441 1.016-5.905 2.622l-1.956-1.314c.025-.384.029-.772.007-1.162 3.032.168 5.927-1.099 7.854-3.421 1.928 2.322 4.828 3.59 7.854 3.421-.17 3.032 1.099 5.927 3.421 7.854-2.323 1.928-3.591 4.823-3.421 7.854-3.026-.167-5.927 1.099-7.854 3.421-1.813-2.185-4.482-3.436-7.317-3.436-.179 0-.357.005-.537.015.17-3.032-1.099-5.927-3.421-7.854 1.452-1.204 2.491-2.787 3.025-4.544l1.187.797c-.596 1.119-.937 2.394-.937 3.747 0 4.411 3.589 8 8 8z" }),
    _react2.default.createElement("path", { d: "m49 23h8v-8h-8zm2-6h4v4h-4z" }),
    _react2.default.createElement("path", { d: "m39 23h8v-8h-8zm2-6h4v4h-4z" }),
    _react2.default.createElement("path", { d: "m29 23h8v-8h-8zm2-6h4v4h-4z" }),
    _react2.default.createElement("path", { d: "m57 57h2v2h-2z" }),
    _react2.default.createElement("path", { d: "m53 57h2v2h-2z" }),
    _react2.default.createElement("path", { d: "m49 57h2v2h-2z" })
  );
};

exports.default = Encroachment;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/encroachment.js
// module id = 1763
// module chunks = 895